<ng-container *ngrxLet="vm$ as vm">
  @if (vm.loading || vm.saving) {
    <nty-loading />
  }

  @if (vm.discussion && vm.language && vm.mode !== Mode.None) {
    <ion-header>
      <ion-toolbar>
        <nty-discussion-unsaved-changes [lang]="vm.language" [saved]="formService.saved" />

        @if (vm.readonly) {
          <terra-status-badge color="success" slot="end">Complete</terra-status-badge>
        }
      </ion-toolbar>

      <ion-toolbar id="discussion-title-toolbar">
        <h1 class="terra-headline-3">{{ vm.discussion.title ?? '' }}</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content id="form-container" [formGroup]="formService.form">
      <nty-discussion-form-participants
        [discussion]="vm.discussion"
        [highlight]="(stepperStore.isManagerSection$ | async) ? 'manager' : 'managee'" />

      @switch (stepperStore.currentSection$ | async) {
        @case (stepperStore.ManageeSections.CoreValues) {
          <nty-core-values-form [discussion]="vm.discussion" [mode]="vm.mode" formControlName="coreValues" />
        }
        @case (stepperStore.ManageeSections.RoleRatings) {
          <nty-role-ratings-form
            [discussion]="vm.discussion"
            [mode]="vm.mode"
            [language]="vm.language"
            formControlName="roleRatings" />
        }
        @case (stepperStore.ManageeSections.PerfData) {
          <nty-discussion-performance-data-form [discussion]="vm.discussion" [mode]="vm.mode" />
        }
        @case (stepperStore.ManageeSections.CustomQuestions) {
          <nty-custom-question-form
            [discussion]="vm.discussion"
            [mode]="vm.mode"
            [questions]="vm.questions"
            formControlName="customQuestions" />
        }
        @case (stepperStore.ManagerSections.Leadership) {
          <nty-commitments-form [discussion]="vm.discussion" [mode]="vm.mode" formControlName="leadership" />
        }
        @case (stepperStore.ManagerSections.Coaching) {
          <nty-commitments-form
            [discussion]="vm.discussion"
            [mode]="vm.mode"
            type="coachingCommitments"
            formControlName="coaching" />
        }
        @default {}
      }
    </ion-content>

    @if (questionCount$ && errorCount$) {
      <ion-footer>
        <ion-toolbar class="helper-text-toolbar">
          <nty-discussion-form-helper-content
            [questionCount]="questionCount$ | async"
            [errorCount]="errorCount$ | async"
            [readonly]="vm.readonly"
            [language]="vm.language" />
        </ion-toolbar>
        <ion-toolbar class="stepper-toolbar">
          <nty-discussion-form-stepper
            [currentSectionNumber]="vm.currentSectionNumber"
            [sectionCount]="vm.sectionCount"
            [disableFinish]="formService.form.invalid || vm.readonly"
            [readonly]="vm.readonly"
            (saveForLater)="onSave(false)"
            (finished)="onSave(true)" />
        </ion-toolbar>
      </ion-footer>
    }
  } @else {
    <nty-loading />
  }
</ng-container>
